import * as types from '../constants/idpAdminActions';
import {
  addSpApi,
  deleteAppApi,
  deleteAppsApi,
  getAppApi,
  importFromXmlApi,
  importUrlApi,
  updateAppApi,
  startUsingNewIdpCertificateApi,
  generateOidcClientCredentialsApi
} from "../api/api";
import {CONTAIN, USER_DISPLAY_NAME} from '../constants/samlConstants';
import {
  ADD_SP_METADATA_SAVED,
  CANCEL_ADD_SAML,
  DELETE_APP_FAIL,
  DELETE_APP_OK,
  OPEN_HELP_DOC_PAGE
} from "../constants/postMessages";
import {SAML2_APPLICATION, OIDC_APPLICATION, WS_FEDERATION_APPLICATION} from "../constants/applicationTypes.js";
import {getOrigin, getSessionToken} from "./storage";

export const importUrlStart = () => ({
  type: types.PARSE_FROM_URL_START
});
export const importUrlSuccess = (metadata) => ({
  type: types.PARSE_FROM_URL_SUCCESS,
  metadata,
});
export const importUrlFail = (errorMsg) => ({
  type: types.PARSE_FROM_URL_FAIL,
  errorMsg,
});

export function importUrl(parseUrl) {
  return (dispatch) => {
    dispatch(importUrlStart());
    return importUrlApi(parseUrl)
    .then(response => {
      dispatch(importUrlSuccess(response));
    })
    //Handle errors
    .catch(error => {
      return error.response.json().then(r => {
        //Handle a specific error when there are no valid certificates
        if (r.errorMessage === "SP_METADATA_NO_VALID_CERTIFICATES") {
          dispatch(showModalExpiredMetadataCertificate())
        }
        else {
          dispatch(importUrlFail(r.errorMessage));
        }
      }).catch(error => dispatch(importUrlFail()));
    })
  }
}

export const importXmlStart = () => ({
  type: types.PARSE_FROM_XML_START
});
export const importXmlSuccess = (metadata) => ({
  type: types.PARSE_FROM_XML_SUCCESS,
  metadata,
});
export const importXmlFail = (errorMsg) => ({
  type: types.PARSE_FROM_XML_FAIL,
  errorMsg,
});

export const clearImportUrl = () => ({
  type: types.CLEAR_IMPORT_URL
});

export const addSpStart = () => ({
  type: types.ADD_SP_START
});
export const addSpSuccess = () => ({
  type: types.ADD_SP_SUCCESS
});
export const addSpFail = (errorMsg) => ({
  type: types.ADD_SP_FAIL,
  errorMsg,
});

export function addSp(metadata) {
  return (dispatch) => {
    const newMeta = {
      "name": metadata.name.trim(),
      "userFriendlyName": metadata.userFriendlyName.trim(),
      "applicationType" : metadata.applicationType.trim(),
      "spSaml2Metadata": metadata.spSaml2Metadata
    };
    dispatch(addSpStart());
    return addSpApi(newMeta)
    .then(response => {
      dispatch(addSpSuccess());
      window.parent.postMessage(ADD_SP_METADATA_SAVED, getOrigin());
    })
    .catch((error) => {
      return error.response.json().then(r => {
        //Handle a specific error returned from server
        if (r.errorMessage) {
          dispatch(addSpFail(r.errorMessage));
        }
      }).catch(error => dispatch(addSpFail(error.message)));
    });
  }
}

export const generateOidcClientCredentialsStart = () => ({
  type: types.GENERATE_OIDC_CLIENT_CREDENTIALS_START
});

export const generateOidcClientCredentialsSuccess = (response) => ({
  type: types.GENERATE_OIDC_CLIENT_CREDENTIALS_SUCCESS,
  response
});
export const generateOidcClientCredentialsFail = (errorMsg) => ({
  type: types.GENERATE_OIDC_CLIENT_CREDENTIALS_FAIL,
  errorMsg,
});

export function generateOidcClientCredentials(appId) {
  return (dispatch) => {
    dispatch(generateOidcClientCredentialsStart());
    return generateOidcClientCredentialsApi(appId)
        .then(response => {
          dispatch(generateOidcClientCredentialsSuccess(response));
        })
        .catch((error) => {
          dispatch(generateOidcClientCredentialsFail(error.message));
        });
  }
}

export const addOidcStart = () => ({
  type: types.ADD_OIDC_APP_START
});

export const addOidcSuccess = (response) => ({
  type: types.ADD_OIDC_APP_SUCCESS,
  response
});
export const addOidcFail = (errorMsg) => ({
  type: types.ADD_OIDC_APP_FAIL,
  errorMsg,
});

export function addOidc(metadata) {
  return (dispatch) => {
    const newMeta = {
      "name": metadata.name.trim(),
      "userFriendlyName": metadata.userFriendlyName.trim(),
      "applicationType": metadata.applicationType.trim(),
      "oidcProfile": metadata.oidcProfile
    };
    dispatch(addOidcStart());
    return addSpApi(newMeta)
    .then(response => {
      dispatch(addOidcSuccess(response));
      window.parent.postMessage(ADD_SP_METADATA_SAVED, getOrigin());
    })
    .catch((error) => {
      return error.response.json().then(r => {
        //Handle a specific error
        if (r.errorMessage) {
          dispatch(addOidcFail(r.errorMessage));
        }
      }).catch(error => dispatch(addOidcFail(error.message)));
    });
  }
}

export const updateAppStart = () => ({
  type: types.UPDATE_APPLICATION_START
});
export const updateAppSuccess = () => ({
  type: types.UPDATE_APPLICATION_SUCCESS
});
export const updateAppFail = (errorMsg) => ({
  type: types.UPDATE_APPLICATION_FAIL,
  errorMsg,
});

export function updateApp(metadata) {
  return (dispatch) => {
    const newMeta = {
      "name": metadata.name.trim(),
      "userFriendlyName": metadata.userFriendlyName.trim(),
      "applicationType" : metadata.applicationType,
      "spSaml2Metadata": metadata.spSaml2Metadata,
      "applicationId": metadata.applicationId,
      "oidcProfile" : metadata.oidcProfile,
      "wsFederationProfile" : metadata.wsFederationProfile
    };
    dispatch(updateAppStart());
    return updateAppApi(metadata.applicationId, newMeta)
    .then(function () {
      dispatch(updateAppSuccess());
      window.parent.postMessage(ADD_SP_METADATA_SAVED, getOrigin());
    }).catch((error) => {
      return error.response.json().then(r => {
        //Handle a specific error returned from server
        if (r.errorMessage) {
          dispatch(updateAppFail(r.errorMessage));
        }
      }).catch(error => dispatch(updateAppFail(error.message)));
    });
  }
}

export function startUsingNewIdpCertificate(applicationId) {
  return (dispatch) => {
    return startUsingNewIdpCertificateApi(applicationId)
      .then(response => {
        dispatch(startUsingNewIdpCertificateSuccess(response));
      })
      .catch((error) => {
        dispatch(getAppFail(error.message));
      });
  }
}
export const startUsingNewIdpCertificateSuccess = (metadata) => ({
    type: types.START_USING_NEW_IDP_CERTIFICATE_SUCCESS,
    metadata
});

export const getAppStart = () => ({
  type: types.GET_APPLICATION_START
});
export const getAppSuccess = (metadata) => {
  // eslint-disable-next-line default-case
  switch (metadata.applicationType) {
    case SAML2_APPLICATION:
      return {
        type: types.GET_SAML_APPLICATION_SUCCESS,
        metadata
      };
    case OIDC_APPLICATION:
      return {
        type: types.GET_OIDC_APPLICATION_SUCCESS,
        metadata
      };
    case WS_FEDERATION_APPLICATION:
      return {
        type: types.GET_WS_FED_APPLICATION_SUCCESS,
        metadata
      };
  }
};

export const getAppFail = (errorMsg) => ({
  type: types.GET_APPLICATION_FAIL,
  errorMsg,
});

export function getApp(applicationId) {
  return (dispatch) => {
    dispatch(getAppStart());
    return getAppApi(applicationId)
    .then(response => {
      dispatch(getAppSuccess(response));
    })
    .catch((error) => {
      dispatch(getAppFail(error.message));
    });
  }
}

export function importFromXml(file) {
  const data = new FormData();
  data.append("SpMetadataXml", file);
  return (dispatch) => {
    dispatch(importXmlStart());
    return importFromXmlApi(data)
    .then(response => {
      dispatch(importXmlSuccess(response));
    })
    //Handle errors
    .catch(error => {
      return error.response.json().then(r => {
        //Handle a specific error when there are no valid certificates
        if (r.errorMessage === "SP_METADATA_NO_VALID_CERTIFICATES") {
          dispatch(showModalExpiredMetadataCertificate())
        }
        else {
          dispatch(importXmlFail(r.errorMessage));
        }
      }).catch(error => dispatch(importXmlFail()));
    })
  }
}

export function deleteApp(applicationIds) {
  return (dispatch) => {
    if (getSessionToken()) {
      dispatch(deleteAppStart());
      const arrAppIds = applicationIds.split(',').filter((appId) => {
        return appId !== "";
      });
      let count = 0;
      arrAppIds.forEach((appId) => {
        deleteAppApi(appId)
        .then(response => {
          if (response.status !== 404 && response.status !== 200) {
            dispatch(deleteAppFail());
            window.parent.postMessage(DELETE_APP_FAIL, getOrigin());
          } else if (++count === arrAppIds.length) {
            dispatch(deleteAppSuccess());
            window.parent.postMessage(DELETE_APP_OK, getOrigin());
          }
        })
        .catch((error) => {
          dispatch(deleteAppFail(error.message));
          window.parent.postMessage(DELETE_APP_FAIL, getOrigin());
        });
      });
    }
  }
}

export function deleteApps(applicationIds) {
  return (dispatch) => {
    if (getSessionToken()) {
      dispatch(deleteAppStart());
      let arrAppIds = applicationIds.split(',').filter((appId) => {
        return appId !== "";
      })
      const appIds = {
        "applications": arrAppIds
      }
      deleteAppsApi(appIds)
      .then(response => {
        if (response.status !== 200) {
          throw new Error("Application deleting fail");
        } else {
          return response.json();
        }
      })
      .then(response => {
        //From back-end we receive response, which contains object like
        // "{ 123: true, 345: true, 33: false}".
        // Using "for .. in" we check each field in this object.
        // If all fields are "true" we will send "delete_app_ok" to appliance,
        // but if we meet at least one field which is "false" we will send "delete_app_fail"
        for (let key in response) {
          if (!response[key]) {
            //After this command will be executed catch block
            throw new Error("Application deleting fail");
          }
        }
        dispatch(deleteAppSuccess());
        window.parent.postMessage(DELETE_APP_OK, getOrigin());
      })
      .catch((error) => {
        dispatch(deleteAppFail(error.message));
        window.parent.postMessage(DELETE_APP_FAIL, getOrigin());
      });
    }
  }
}

export const deleteAppStart = () => ({
  type: types.DELETE_SP_START
});
export const deleteAppSuccess = () => ({
  type: types.DELETE_SP_SUCCESS,
});
export const deleteAppFail = (errorMsg) => ({
  type: types.DELETE_SP_FAIL,
  errorMsg,
});

export function cancelAddApp() {
  window.parent.postMessage(CANCEL_ADD_SAML, getOrigin());
  return {
    type: types.CANCEL_ADD_APPLICATION
  }
}

export const addUserAttributeConst = (newUserAttribute) => ({
  type: types.ADD_USER_ATTRIBUTE,
  newUserAttribute
});

export const deleteUserAttributeConst = (targetAttribute) => ({
  type: types.DELETE_USER_ATTRIBUTE,
  targetAttribute
});

export const updateUserAttributesConst = (payload) => ({
  type: types.UPDATE_USER_ATTRIBUTES,
  payload
});

export const addUserGroupAttributeConst = (newUserGroupAttribute) => ({
  type: types.ADD_USER_GROUP_ATTRIBUTE,
  newUserGroupAttribute
});

export const deleteUserGroupAttributeConst = (targetAttribute) => ({
  type: types.DELETE_USER_GROUP_ATTRIBUTE,
  targetAttribute
});

export const updateUserGroupAttributesConst = (payload) => ({
  type: types.UPDATE_USER_GROUP_ATTRIBUTES,
  payload
});

export const recoverAppConst = (payload) => ({
  type: types.RECOVER_APPLICATION,
  payload
});

export const replaceAppConst = (payload, appId, lastCertificateRotationDate) => ({
  type: types.REPLACE_APPLICATION,
  payload,
  appId,
  lastCertificateRotationDate
});

export function deleteUserAttribute(target) {
  return (dispatch) => {
    dispatch(deleteUserAttributeConst(target));
  }
}

export function addUserAttribute() {
  return (dispatch) => {
    let newUserAttribute = {
      'userAttributeName': "",
      'idpUserAttributeEnum': USER_DISPLAY_NAME,
      'userSpecifiedValue': "",
    }
    dispatch(addUserAttributeConst(newUserAttribute));
  }
}

export function updateUserAttributes(evt) {
  return (dispatch) => {
    dispatch(updateUserAttributesConst(evt));
  }
}

export function deleteUserGroupAttribute(target) {
  return (dispatch) => {
    dispatch(deleteUserGroupAttributeConst(target));
  }
}

export function addUserGroupAttribute() {
  return (dispatch) => {
    let newUserGroupAttribute = {
      'userGroupAttributeName': "",
      'idpGroupAttributeFilterEnum': CONTAIN,
      'idpGroupAttributeFilterValue': "",
    }
    dispatch(addUserGroupAttributeConst(newUserGroupAttribute));
  }
}

export function updateUserGroupAttributes(evt) {
  return (dispatch) => {
    dispatch(updateUserGroupAttributesConst(evt));
  }
}

export function recoverApp(payload) {
  return (dispatch) => {
    dispatch(recoverAppConst(payload));
  }
}

export function replaceApp(payload, appId, lastCertificateRotationDate) {
  return (dispatch) => {
    dispatch(replaceAppConst(payload, appId, lastCertificateRotationDate));
  }
}

export const clearErrorMessage = () => ({
  type: types.CLEAR_ERROR_MESSAGE
});

export const updateAppNameConst = (payload) => ({
  type: types.UPDATE_APP_NAME,
  payload
});

export function updateAppName(payload) {
  return (dispatch) => {
    dispatch(updateAppNameConst(payload));
  }
}

export const updateUserFriendlyNameConst = (payload) => ({
  type: types.UPDATE_USER_FRIENDLY_NAME,
  payload
});

export function updateUserFriendlyName(payload) {
  return (dispatch) => {
    dispatch(updateUserFriendlyNameConst(payload));
  }
}

export const updateDefaultNameIdConst = (payload) => ({
  type: types.UPDATE_DEFAULT_NAME_ID,
  payload
});

export function updateDefaultNameId(payload) {
  return (dispatch) => {
    dispatch(updateDefaultNameIdConst(payload));
  }
}

export const updateUnspecifiedNameIdFormatAttributeConst = (payload) => ({
  type: types.UPDATE_UNSPECIFIED_NAME_ID_FORMAT_ATTRIBUTE,
  payload
});

export function updateUnspecifiedNameIdFormatAttribute(payload) {
  return (dispatch) => {
    dispatch(updateUnspecifiedNameIdFormatAttributeConst(payload));
  }
}

export const clearMessages = () => ({
  type: types.CLEAR_MESSAGES,
});

export const setErrorMessage = (errorMsg) => ({
  type: types.SET_ERROR_MESSAGE,
  errorMsg
});

export const updateDownloadUrlConst = (payload) => ({
  type: types.UPDATE_DOWNLOAD_URL,
  payload
});

export function updateDownloadUrl(payload) {
  return (dispatch) => {
    dispatch(updateDownloadUrlConst(payload));
  }
}

export const showImportModalPopupConst = () => ({
  type: types.SHOW_IMPORT_MODAL,
});
export const hideImportModalPopupConst = () => ({
  type: types.HIDE_IMPORT_MODAL,
});

export function showImportModalPopup() {
  return (dispatch) =>
      dispatch(showImportModalPopupConst());
}

export function hideImportModalPopup() {
  return (dispatch) =>
      dispatch(hideImportModalPopupConst());
}

export const showModalViewAllMetadataConst = () => ({
  type: types.SHOW_ALL_METADATA_MODAL,
});
export const hideModalViewAllMetadataConst = () => ({
  type: types.HIDE_ALL_METADATA_MODAL,
});

export function showModalViewAllMetadata() {
  return (dispatch) =>
      dispatch(showModalViewAllMetadataConst());
}

export function hideModalViewAllMetadata() {
  return (dispatch) =>
      dispatch(hideModalViewAllMetadataConst());
}

export const showModalExpiredMetadataCertificateConst = () => ({
  type: types.SHOW_EXPIRED_METADATA_CERTIFICATE_MODAL,
});
export const hideModalExpiredMetadataCertificateConst = () => ({
  type: types.HIDE_EXPIRED_METADATA_CERTIFICATE_MODAL,
});

export function showModalExpiredMetadataCertificate() {
  return (dispatch) =>
      dispatch(showModalExpiredMetadataCertificateConst());
}

export function hideModalExpiredMetadataCertificate() {
  return (dispatch) =>
      dispatch(hideModalExpiredMetadataCertificateConst());
}

export const showModalStartUsingNewIdpCertificateConst = () => ({
  type: types.SHOW_START_USING_NEW_IDP_CERTIFICATE_MODAL,
});
export const hideModalStartUsingNewIdpCertificateConst = () => ({
  type: types.HIDE_START_USING_NEW_IDP_CERTIFICATE_MODAL,
});

export function showModalStartUsingNewIdpCertificate() {
  return (dispatch) =>
      dispatch(showModalStartUsingNewIdpCertificateConst());
}

export function hideModalStartUsingNewIdpCertificate() {
  return (dispatch) =>
      dispatch(hideModalStartUsingNewIdpCertificateConst());
}

export const changeSelectedImportOptionConst = (payload) => ({
  type: types.CHANGE_SELECTED_IMPORT_OPTION,
  payload
});

export function changeSelectedImportOption(payload) {
  return (dispatch) =>
      dispatch(changeSelectedImportOptionConst(payload));
}

export const addOidcRedirectUriConst = (newOidcRedirectUri) => ({
  type: types.ADD_OIDC_REDIRECT_URI,
  newOidcRedirectUri
});

export const deleteOidcRedirectUriConst = (targetOidcRedirectUri) => ({
  type: types.DELETE_OIDC_REDIRECT_URI,
  targetOidcRedirectUri
});

export const updateOidcRedirectUriConst = (payload) => ({
  type: types.UPDATE_OIDC_REDIRECT_URI,
  payload
});

export function deleteOidcRedirectUri(target) {
  return (dispatch) => {
    dispatch(deleteOidcRedirectUriConst(target));
  }
}

export function addOidcRedirectUri() {
  return (dispatch) => {
    let newOidcRedirectUri = {
      'redirectUri': "",
      'redirectUriType': 0,
    }
    dispatch(addOidcRedirectUriConst(newOidcRedirectUri));
  }
}

export function updateOidcRedirectUri(evt) {
  return (dispatch) => {
    dispatch(updateOidcRedirectUriConst(evt));
  }
}

export function openHelpDocPage(url) {
  window.parent.postMessage(JSON.stringify({
    type: OPEN_HELP_DOC_PAGE,
    url: url
  }), getOrigin());
  return {
    type: types.OPEN_HELP_DOC_PAGE
  }
}

export const addWsFedStart = () => ({
  type: types.ADD_WS_FED_APP_START
});

export const addWsFedSuccess = (response) => ({
  type: types.ADD_WS_FED_APP_SUCCESS,
  response
});
export const addWsFedFail = (errorMsg) => ({
  type: types.ADD_WS_FED_APP_FAIL,
  errorMsg,
});

export function addWsFed(metadata) {
  return (dispatch) => {
    const newMeta = {
      "name": metadata.name.trim(),
      "userFriendlyName": metadata.userFriendlyName.trim(),
      "applicationType": metadata.applicationType.trim(),
      "wsFederationProfile": metadata.wsFederationProfile
    };
    dispatch(addWsFedStart());
    return addSpApi(newMeta)
      .then(response => {
        dispatch(addWsFedSuccess(response));
      })
      .catch((error) => {
        return error.response.json().then(r => {
          //Handle a specific error
          if (r.errorMessage) {
            dispatch(addWsFedFail(r.errorMessage));
          }
        }).catch(error => dispatch(addWsFedFail(error.message)));
      });
  }
}

export const updateWsFedRedirectUriConst = (payload) => ({
  type: types.UPDATE_WS_FED_REDIRECT_URI,
  payload
});

export function updateWsFedRedirectUri(payload) {
  return (dispatch) => {
    dispatch(updateWsFedRedirectUriConst(payload));
  }
}

export const showWsFedIdpMetadataPopupConst = () => ({
  type: types.SHOW_WS_FED_IDP_METADATA_POPUP,
});
export const hideWsFedIdpMetadataPopupConst = () => ({
  type: types.HIDE_WS_FED_IDP_METADATA_POPUP,
});

export function showWsFedIdpMetadataPopup() {
  return (dispatch) =>
      dispatch(showWsFedIdpMetadataPopupConst());
}

export function hideWsFedIdpMetadataPopup() {
  return (dispatch) =>
      dispatch(hideWsFedIdpMetadataPopupConst());
}

/* Oidc custom claims actions */
export function addScope() {
  return (dispatch) => {
    dispatch({
      type: types.ADD_SCOPE
    });
  }
}

export function updateScope(updatedScopeIndex, updatedScope) {
  return (dispatch) => {
    dispatch({
      type: types.UPDATE_SCOPE,
      updatedScopeIndex,
      updatedScope
    });
  }
}

export function deleteScope(scopeToDeleteIndex, scopeToDelete) {
  return (dispatch) => {
    dispatch({
      type: types.DELETE_SCOPE,
      scopeToDeleteIndex,
      scopeToDelete
    });
  }
}



// WEBPACK FOOTER //
// ./src/actions/sp.js